import { render, staticRenderFns } from "./ReportShippop.vue?vue&type=template&id=dd0bf09a&scoped=true"
import script from "./ReportShippop.vue?vue&type=script&lang=js"
export * from "./ReportShippop.vue?vue&type=script&lang=js"
import style0 from "./ReportShippop.vue?vue&type=style&index=0&id=dd0bf09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0bf09a",
  null
  
)

export default component.exports